(() => {
  if (window.__syGrowthMeasurement || window.Shopify?.designMode || /(?:preview_theme_id|preview_key)=/.test(location.search)) return;
  const node = document.getElementById('sy-growth-context');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  if (config.measurement_id !== 'G-1DQG22XPRH') return;
  window.__syGrowthMeasurement = true;
  const storageKey = 'sy-article-origin-v1';
  const contextFields = ['article_handle', 'article_world', 'article_topic', 'article_cluster'];
  const context = Object.fromEntries(contextFields.map(key => [key, typeof config[key] === 'string' ? config[key].trim().slice(0,100) : '']));
  context.article_handle = context.article_handle.split('/').pop();
  const worlds = new Set(['/pages/money-business', '/pages/creator-marketing', '/pages/ai-technology', '/pages/mindset-communication', '/pages/life-health-confidence']);
  let viewed = false;
  const clearOrigin = () => { try { sessionStorage.removeItem(storageKey); } catch {} };
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return !!privacy && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed() && (!privacy.saleOfDataAllowed || privacy.saleOfDataAllowed());
  };
  const send = (event, fields) => {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    const options = {...fields, send_to:config.measurement_id, transport_type:'beacon'};
    try { window.gtag('event', event, options); } catch { return false; }
    return true;
  };
  const view = () => {
    // Privacy initialization is not a denial; keep consented context until the API is ready.
    if (!window.Shopify?.customerPrivacy) return;
    if (!allowed()) { clearOrigin(); return; }
    if (config.page_type === 'article' && context.article_handle && !viewed) {
      viewed = send('article_view', {...context, source_component:'article_page'});
    }
  };
  const remember = handle => {
    try { sessionStorage.setItem(storageKey, JSON.stringify({...context, resource_handle:handle, expires_at:Date.now()+30*60*1000})); } catch {}
  };
  const readOrigin = () => {
    if (!window.Shopify?.customerPrivacy) return null;
    if (!allowed()) { clearOrigin(); return null; }
    try {
      const origin = JSON.parse(sessionStorage.getItem(storageKey));
      if (!origin || !Number.isFinite(origin.expires_at) || origin.expires_at <= Date.now()) { clearOrigin(); return null; }
      if (origin.resource_handle !== config.product_handle) return null;
      return Object.fromEntries(contextFields.map(key => [key, typeof origin[key] === 'string' ? origin[key].slice(0,100) : '']));
    } catch { clearOrigin(); return null; }
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.button > 0 || !allowed()) return;
    let destination;
    try { destination = new URL(link.href, location.href); } catch { return; }
    if (destination.origin !== location.origin || link.hasAttribute('download')) return;
    const pathname = destination.pathname.replace(/\/$/, '');
    const handle = pathname.split('/').filter(Boolean).pop() || 'home';
    const sendClick = (name, fields) => send(name, fields);
    if (config.page_type === 'product') {
      if (!link.matches('[data-sy-primary-cta], [data-sy-secondary-cta]')) return;
      const origin = readOrigin();
      if (origin) sendClick('membership_cta_click', {...origin, source_component:'resource_access', destination_handle:handle, cta_type:link.matches('[data-sy-primary-cta]') ? 'primary' : 'all_access'});
      return;
    }
    if (!context.article_handle || !link.closest('#MainContent')) return;
    if (link.closest('[data-sy-article-resource]') && pathname.startsWith('/products/')) {
      const tracked = sendClick('go_deeper_click', {...context, source_component:'go_deeper', destination_handle:handle, cta_type:link.querySelector('img') ? 'artwork' : 'button'});
      if (tracked) remember(handle);
      return;
    }
    if (link.closest('[data-sy-article-related]') && pathname.startsWith('/blogs/')) {
      sendClick('related_article_click', {...context, source_component:'related_articles', destination_handle:handle, cta_type:'article'});
      return;
    }
    const type = worlds.has(pathname) ? 'world' : pathname.startsWith('/collections/') ? 'topic' : pathname.startsWith('/products/') ? 'product' : pathname.startsWith('/blogs/') && pathname !== location.pathname ? 'article' : null;
    if (type) sendClick('article_navigation_click', {...context, source_component:link.closest('[data-sy-article-content]') ? 'article_body' : 'article_metadata', destination_handle:handle, cta_type:type});
  });
  document.addEventListener('visitorConsentCollected', view);
  window.addEventListener('load', view, {once:true});
  view();
  // The official tag can finish loading after this deferred asset.
  window.setTimeout(view, 1500);
  window.setTimeout(view, 5000);
})();
